import {
  changePassword,
  forceLogout,
  login,
  logout,
  updateAccountInfo,
} from '@redux/actions';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AuthState = {
  jwt: '',
  user: null,
  config: {},
};

const removeAuth = (state: AuthState) => {
  state.jwt = '';
  state.user = null;
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(forceLogout, removeAuth)
      .addCase(login.fulfilled, (state, { payload }) => {
        if (!payload.user.forceChangePassword && !payload.user.isNew) {
          state.jwt = payload.jwt;
          state.user = payload.user;
          if (payload.user.id !== state.config?.accountId) {
            state.config = {
              accountId: payload.user.id,
              event: { time: 30, enabled: true },
            };
          }
        }
      })
      .addCase(logout.fulfilled, removeAuth)
      .addCase(changePassword.fulfilled, removeAuth)
      .addCase(updateAccountInfo.fulfilled, (state, { payload }) => {
        if (state.user && payload.data) {
          state.user = { ...state.user, ...payload?.data };
        }
      });
  },
});

// export const { logout } = authSlice.actions;

export default authSlice.reducer;
